import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
  allorders: [],
  loading: false,
  error: null,
};

const orderSlice = createSlice({
  name: "allorders",
  initialState,
  reducers: {
    fetchOrdersStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchOrdersSuccess: (state, action) => {
      state.loading = false;
      state.allorders = action.payload;
    },
    fetchOrdersFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { fetchOrdersStart, fetchOrdersSuccess, fetchOrdersFailure } = orderSlice.actions;

export const fetchOrders = () => async (dispatch) => {
  dispatch(fetchOrdersStart());
  try {
    const token = localStorage.getItem('authToken'); 
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/orders/admin/allorders`, {
        headers: {
          'Authorization': `Bearer ${token}`, 
        },
      });
    dispatch(fetchOrdersSuccess(response.data));
  } catch (error) {
    dispatch(fetchOrdersFailure(error.message));
  }
};

export default orderSlice.reducer;
